import {Component, Input, Inject} from 'ng-metadata/core';
import {IStateParamsService} from 'angular-ui-router';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service';
import {SharedSessionStorage} from '../../../infra/sharedSessionStorage.service';
import {getVid} from '../../../appConfig/appConfigForward';
import {PrmAlertBar} from '../../../infra/widgets/alerts/alertBar.directive';
import {AlertFactory,ALERT_MSG_TYPE} from '../../../infra/widgets/alerts/alertFactory.service';
import {IAlertMsg} from '../../../infra/widgets/alerts/alertMsg.interface';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {PersonalizationDialogService} from './personalizationDialog.service';
import {PersonalizeResultsButtonService} from "../personalizationButton/personalizeResultsButton.service";
import {PrimolyticsService,beacon} from '../../../analytics/primolytics.service';
import {isBrowserIE} from "../../../infra/browserSniffer";

const groupBy= require('lodash/groupBy');
const sortBy = require('lodash/sortBy');
const fromPairs = require('lodash/fromPairs');
const extend = require('lodash/extend');

@Component({
    selector: 'prm-personalization-dialog',
    templateUrl: 'components/search/personalization/personalizationDialog/personalization-dialog.html',
})

export class PrmPersonalizationDialog{

    private vid: string = getVid();
    private maxDisciplines:IAlertMsg;
    public sortedDisc = [];
    public subDisc = [];
    public sortedSub = [];
    public selectedDisc = {};
    public subMap = {};
    private isIe = isBrowserIE();
    private KEY_CODE= {
        COMMA: 188,
        SEMICOLON : 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW : 37,
        UP_ARROW : 38,
        RIGHT_ARROW : 39,
        DOWN_ARROW : 40,
        TAB : 9,
        BACKSPACE: 8,
        DELETE: 46
    };


    constructor(private personalizeResultsButtonService: PersonalizeResultsButtonService,
                private mappingTablesCache: MappingTablesCache,
                private sharedSessionStorage: SharedSessionStorage,
                private personalizationDialogService: PersonalizationDialogService,
                @Inject('$translate') private $translate,
                @Inject('$state') private $state: ng.ui.IStateService,
                private alertService:AlertFactory,
                private primolyticsService: PrimolyticsService,
                @Inject('$stateParams') private $stateParams : IStateParamsService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {

        this.maxDisciplines = alertService.create(ALERT_MSG_TYPE.SIMPLE_WITHOUT_DISMISS);
        this.maxDisciplines.show('nui.validation.pyr.maxDisciplines');

        let personalization= this.mappingTablesCache.findByProperties('Personalize Your Results Disciplines Fields', {source1: this.vid});
        if (personalization.length === 0){
            personalization= this.mappingTablesCache.findByProperties('Personalize Your Results Disciplines Fields', {source1: 'default'});
         }

        let disciplines = personalization.filter((discipline) => !discipline.source2);
        disciplines = disciplines.map((discipline) => discipline.target);
        let subDisciplines = personalization.filter((discipline) => discipline.source2);
        subDisciplines = subDisciplines.map((sub) => {
            return {disc: sub.source2, subDisc: sub.target}
        });
        let grouping = groupBy(subDisciplines, 'disc');
        Object.keys(grouping).forEach((key) => {
            this.subDisc['pyr.discipline.' + key] = grouping[key].map((sub) => 'pyr.discipline.' + sub.subDisc)
        });
        disciplines = disciplines.map((disc) => 'pyr.discipline.' + disc);

        this.subMap = this.createSubMap();

        //Translate the disciplines and then sort them according to the label
        this.$translate(disciplines).then((translation)=> {
            this.sortedDisc = Object.entries(translation);
            this.sortedDisc.sort((a,b) => a[1].localeCompare(b[1]));
         });


        Object.keys(this.subDisc).forEach((res,index) => {
            this.$translate(this.subDisc[res]).then((translation)=> {
                let entries = Object.entries(translation);
                let sorted = entries.sort((a,b) => a[1].localeCompare(b[1]));
                this.sortedSub.push([res, sorted]);
            })
         });

         this.initSelectedDisiplines();
    }

    getsubDisciplines(discipline) {
        let sortedObj = fromPairs(this.sortedSub);
        return sortedObj[discipline];
    }

    get enable() {
        return this.personalizeResultsButtonService.enable;
    }

    public personalize() {
        let preferred = [];
        Object.keys(this.selectedDisc).forEach((key) => {
            if (this.selectedDisc[key]) {
                preferred.push(key);
            }
        });

        if (preferred.length > 0) {
            this.$translate(preferred).then((translation)=> {
                let entries = Object.entries(translation);
                let sorted = entries.sort((a,b) => a[1].localeCompare(b[1]));
                let personalizationArr = sorted.map((disc) => disc[0].replace('pyr.discipline.',''));
                let currentPersonalization = this.sharedSessionStorage.getItem('personalization');
                this.sharedSessionStorage.setItem('personalization', personalizationArr.join(';'));
				if (currentPersonalization != personalizationArr.join(';'))
                    this.reloadStateWithBeacon();
                else
                    this.reloadStateWithoutBeacon();

                if(this.personalizationDialogService.isSignedIn()){
                    this.personalizeResultsButtonService.setUserPersonalizationPreferencesToDB(this.$stateParams['vid']);
                }
            });

        }
        //When the user presses 'edit' and then cleans the list
        else if (preferred.length === 0 && this.sharedSessionStorage.getItem('personalization') !== null) {
            this.resetPersonalization();
        }
        this.personalizeResultsButtonService.editPressed= false;
    }

    @beacon({'p': 'personalizedResults', 'op': 'updated'})
    private reloadStateWithBeacon() {
        this.personalizeResultsButtonService.addCameFromPersonalizationParam();
        this.$state.go(STATE_NAMES.SEARCH, this.personalizeResultsButtonService.searchParams, {reload: true});
    }

    private reloadStateWithoutBeacon() {
        this.$state.go(STATE_NAMES.SEARCH,{}, {reload: true});
    }

	@beacon({'p': 'personalizedResults', 'op': 'updated'})
    public resetPersonalization(withBeacon:boolean) {
        this.selectedDisc = {};
        this.personalizationDialogService.resetPersonalization();
        this.personalizeResultsButtonService.addCameFromPersonalizationParam();
        this.$state.go(STATE_NAMES.SEARCH, this.personalizeResultsButtonService.searchParams, {reload: true});
        if(this.personalizationDialogService.isSignedIn()){
            this.personalizeResultsButtonService.setUserPersonalizationPreferencesToDB(this.$stateParams['vid']);
        }
    }

    public displayDialog() {
        return this.personalizeResultsButtonService.displayDialog();
    }

    public isPreferredSaved(){
        if (this.sharedSessionStorage.getItem('personalization') !== null)  {
            return true;
        }
        return false;
    }

    public isDisabled(discipline) {
        let sub = this.getsubDisciplines(discipline[0]);
        if (!sub) {
            return false;
        }
        sub = sub.map((sub) => sub[0]);
        let disabled = false;
        sub.forEach((res,index) => {
            if (this.selectedDisc[res]) {
                disabled=true;
            }
        });
        return disabled;
    }


    public isDisabledSub(sub) {
        let disc = this.subMap[sub[0]];
        if (this.selectedDisc[disc]) {
            return true;
        }
        return false;
    }

    private createSubMap() {
        let map = {};
        Object.keys(this.subDisc).forEach((res,index) => {
            this.subDisc[res].forEach((sub,index) => {
                map[sub] = res;
            })
        })
        return map;
    }

    private countSelectedDisc(){
        let count = 0;
        Object.keys(this.selectedDisc).forEach((res,index) => {
            if (this.selectedDisc[res]) {
                count = count + 1;
            }
        });
        return count;
    }

    private initSelectedDisiplines() {
        this.selectedDisc = {};
        let personalization = this.sharedSessionStorage.getItem('personalization');
        if (personalization !== null) {
            let preferredArr = personalization.split(';');
             preferredArr.forEach((disc,index) => {
                 this.selectedDisc['pyr.discipline.'+ disc] = true;
             });
        }
    }

    public cancel(e) {
        this.personalizeResultsButtonService.cancelPressed = true;
        this.personalizeResultsButtonService.editPressed = false;
        this.$timeout(() => {
            document.querySelector('#personalizationBtn').focus();
        }, 0);
    }

    public getSliceLen(arr) {
        return Math.ceil(arr.length/2);
    }

    // @HostListener('keydown', ['$event'])
    private keydownSupport (e) {
        let keyCodes = this.KEY_CODE;

        if (e.keyCode === 9) {
            e.preventDefault();
            return document.querySelector('#personalizationDialog').focus();
        }

    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/personalization/personalizationDialog/personalizationDialog.directive.ts